import { render } from "./DetailsPost.vue?vue&type=template&id=7307bccc"
import script from "./DetailsPost.vue?vue&type=script&lang=js"
export * from "./DetailsPost.vue?vue&type=script&lang=js"

import "./DetailsPost.vue?vue&type=style&index=0&id=7307bccc&scope=true&lang=css"

import exportComponent from "C:\\Users\\Plopfox\\Documents\\Julian\\Dev\\Repositorios\\folleselavida-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__